import {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {updateResource} from 'redux-json-api'

import {Typography} from '@mui/material'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import MediumModal from '../../../../../shared_components/mui_base_components/modals/medium_modal/MediumModal'
import MixpanelLogger from '../../../../../lib/MixpanelLogger'
import SessionStore from '../../../../../auth/src/stores/SessionStore'

import {setViewedFlagV2} from '../../../../../lib/userTools'
import {showMobileAppAnnouncement} from '../../../../../lib/bannerTools'

import iosAppAnnouncementImage from '../../../../../shared_assets/ios-app-announcement-image.svg'

import './mobileAppAnnouncement.scss'

const IOS_APP_ID = '1590237847'

export const MobileAppAnnouncement = props => {
  const [showModal, setShowModal] = useState(
    !props.currentUser.isEmpty() &&
    props.currentUser.getIn(['viewed-flags', 'has_seen_onboarding_assessment'], '') && // user should have interacted with onboarding assessment before download prompt
    showMobileAppAnnouncement({currentUser: SessionStore.getState().currentUser}) &&
    !props.currentUser.getIn(['viewed-flags', 'has_seen_mobile_ios_announcement'], '')
  )

  useEffect(() => {
    if (showModal)
      MixpanelLogger.track('view_mobile_download_popup')
  }, [])

  useEffect(() => {
    if (showModal) {
      setViewedFlagV2({
        user: props.currentUser,
        flagToSet: 'has_seen_mobile_ios_announcement',
        updateResource: props.updateResource
      })
    }
  }, [])

  const closeModal = () => {
    setShowModal(false)
  }

  const downloadApp = () => {
    MixpanelLogger.track('click_mobile_download_popup')

    closeModal()
    window.open(`https://apps.apple.com/us/app/everplans/${IOS_APP_ID}`, '_blank')
  }

  if (!showModal) return null

  return (
    <MediumModal
      className='mobile-app-announcement'
      onClose={closeModal}
      open={showModal}>
      <h1 className='heading'>Get the Everplans mobile app!</h1>
      <img
        className='illustration'
        src={iosAppAnnouncementImage}
        alt='Graphical Illustration showing ease of access to important daily life information with mobile'
      />
      <Typography className='description'>
        The Everplans app brings our stellar organizing and planning capabilities to your phone.{' '}
        <strong>Download the iOS app today</strong> for the best Everplans experience!
      </Typography>
      <Button onClick={downloadApp} className='call-to-action'>Download</Button>
    </MediumModal>
  )
}

MobileAppAnnouncement.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  updateResource: PropTypes.func
}

export default connect(null, {updateResource})(MobileAppAnnouncement)
